import { UpdateControlMetadata } from '../validators/helpers';
import {
  getControlDefinitionByPropertyKey,
  checkIfControlIsAlreadyPresentByPropertyKey
} from '../helpers';
import { MemoizedSelector } from '@ngrx/store';

export function SetUserDefinedProperty(target: any, propertyKey: string, key: string, value: any): void {

  UpdateControlMetadata(target, propertyKey, { userDefinedProperties: { [key]: value } });

}

export function GetUserDefinedProperty<UDP>(target: any, propertyKey: string, key: string): UDP {

  if (
    !checkIfControlIsAlreadyPresentByPropertyKey(
      target,
      propertyKey
    )
  ) {
    throw new Error(
      `[UpdateControlMetadata::${propertyKey}] Control definition for '${propertyKey}' is not set`
    );
  }

  const controlMetadata = getControlDefinitionByPropertyKey(target, propertyKey);

  return controlMetadata.userDefinedProperties[key] || null;

}

export function AddToUserDefinedProperty(target: any, propertyKey: string, key: string, value: any) {

  const udp: any[] = GetUserDefinedProperty(target, propertyKey, key) || [];

  udp.push(value);

  SetUserDefinedProperty(target, propertyKey, key, udp);

}

export function AddNamedSelector<T>(target: any, propertyKey: string, name: string, selector: MemoizedSelector<any, T>): void {

  UpdateControlMetadata(target, propertyKey, { selectors: { [name]: selector } });

}
